<template>
  <div class="contact-view">
    <section class="page-header py-5 bg-light">
      <div class="container">
        <h1 class="display-5 fw-bold">Kontakt</h1>
        <p class="lead">Jesteśmy do Twojej dyspozycji. Skontaktuj się z nami w dogodny dla Ciebie sposób.</p>
      </div>
    </section>

    <section class="contact-content py-5">
      <div class="container">
        <div class="row">
          <!-- Dane kontaktowe - lewa kolumna -->
          <div class="col-lg-5 mb-5 mb-lg-0">
            <div class="contact-info-card p-4 bg-white rounded shadow-sm">
              <h3 class="mb-4">Dane kontaktowe</h3>

              <div class="contact-item d-flex mb-4">
                <div class="contact-icon me-3">
                  <i class="fas fa-map-marker-alt fa-2x text-primary"></i>
                </div>
                <div class="contact-text">
                  <h5>Adres</h5>
                  <p class="mb-0">ul. Gościnna 7<br>05-082 Warszawa / Blizne Łaszczyńskiego</p>
                </div>
              </div>

              <div class="contact-item d-flex mb-4">
                <div class="contact-icon me-3">
                  <i class="fas fa-phone fa-2x text-primary"></i>
                </div>
                <div class="contact-text">
                  <h5>Telefon</h5>
                  <p class="mb-0"><a href="tel:+48571464177" class="text-decoration-none">+48 571 464 177</a></p>
                </div>
              </div>

              <div class="contact-item d-flex mb-4">
                <div class="contact-icon me-3">
                  <i class="fas fa-envelope fa-2x text-primary"></i>
                </div>
                <div class="contact-text">
                  <h5>Email</h5>
                  <p class="mb-0">
                    <a href="mailto:biuro@selam.com.pl" class="text-decoration-none">biuro@selam.com.pl</a>
                  </p>
                </div>
              </div>

              <div class="contact-item d-flex">
                <div class="contact-icon me-3">
                  <i class="fas fa-clock fa-2x text-primary"></i>
                </div>
                <div class="contact-text">
                  <h5>Godziny pracy</h5>
                  <p class="mb-0">
                    Poniedziałek - Piątek: 8:00 - 16:00<br>
                    Sobota - Niedziela: Zamknięte
                  </p>
                </div>
              </div>

              <hr class="my-4">

              <!-- <h4 class="mb-3">Śledź nas</h4>
              <div class="social-links">
                <a href="#" class="social-link me-2">
                  <i class="fab fa-facebook-f fa-lg"></i>
                </a>
                <a href="#" class="social-link me-2">
                  <i class="fab fa-linkedin-in fa-lg"></i>
                </a>
                <a href="#" class="social-link">
                  <i class="fab fa-instagram fa-lg"></i>
                </a>
              </div> -->
            </div>
          </div>

          <!-- Formularz kontaktowy - prawa kolumna -->
          <div class="col-lg-7">
            <!-- Zakładki dla różnych typów formularzy -->
            <div class="contact-tabs mb-4">
              <ul class="nav nav-tabs" id="contactTabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="new-client-tab" data-bs-toggle="tab" data-bs-target="#new-client"
                    type="button" role="tab" aria-controls="new-client" aria-selected="true">
                    Nowy klient
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="referral-tab" data-bs-toggle="tab" data-bs-target="#referral"
                    type="button" role="tab" aria-controls="referral" aria-selected="false">
                    Poleć znajomego
                  </button>
                </li>
              </ul>
            </div>

            <div class="tab-content" id="contactTabsContent">
              <!-- Formularz dla nowego klienta -->
              <div class="tab-pane fade show active" id="new-client" role="tabpanel" aria-labelledby="new-client-tab">
                <div class="contact-form-card p-4 bg-white rounded shadow-sm">
                  <h3 class="mb-4">Wyślij wiadomość</h3>
                  <form @submit.prevent="submitForm">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="name" class="form-label">Imię i nazwisko</label>
                        <input type="text" class="form-control" id="name" v-model="form.name" required>
                      </div>

                      <div class="col-md-6 mb-3">
                        <label for="email" class="form-label">Adres email</label>
                        <input type="email" class="form-control" id="email" v-model="form.email" required>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="phone" class="form-label">Numer telefonu</label>
                      <input type="tel" class="form-control" id="phone" v-model="form.phone">
                    </div>

                    <div class="mb-3">
                      <label for="subject" class="form-label">Temat</label>
                      <input type="text" class="form-control" id="subject" v-model="form.subject" required>
                    </div>

                    <div class="mb-4">
                      <label for="message" class="form-label">Wiadomość</label>
                      <textarea class="form-control" id="message" rows="5" v-model="form.message" required></textarea>
                    </div>

                    <div class="form-check mb-4">
                      <input class="form-check-input" type="checkbox" id="consent" v-model="form.consent" required>
                      <label class="form-check-label" for="consent">
                        Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z polityką prywatności.
                      </label>
                    </div>

                    <button type="submit" class="btn btn-primary btn-lg" :disabled="isSubmitting">
                      <span v-if="isSubmitting">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Wysyłanie...
                      </span>
                      <span v-else>Wyślij wiadomość</span>
                    </button>

                    <div v-if="formStatus.message"
                      :class="['alert mt-4', formStatus.success ? 'alert-success' : 'alert-danger']">
                      {{ formStatus.message }}
                    </div>
                  </form>
                </div>
              </div>

              <!-- Formularz dla polecenia znajomego -->
              <div class="tab-pane fade" id="referral" role="tabpanel" aria-labelledby="referral-tab">
                <div class="contact-form-card p-4 bg-white rounded shadow-sm">
                  <h3 class="mb-4">Poleć nas znajomym</h3>
                  <p class="mb-4">Jeśli jesteś zadowolony z naszych usług, poleć nas swoim znajomym. Dla obu stron
                    przygotowaliśmy specjalne rabaty!</p>

                  <form @submit.prevent="submitReferral">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="referrerName" class="form-label">Twoje imię i nazwisko</label>
                        <input type="text" class="form-control" id="referrerName" v-model="referral.referrerName"
                          required>
                      </div>

                      <div class="col-md-6 mb-3">
                        <label for="referrerEmail" class="form-label">Twój email</label>
                        <input type="email" class="form-control" id="referrerEmail" v-model="referral.referrerEmail"
                          required>
                      </div>
                    </div>

                    <hr class="my-4">
                    <h5 class="mb-3">Dane polecanej osoby</h5>

                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="referredName" class="form-label">Imię i nazwisko</label>
                        <input type="text" class="form-control" id="referredName" v-model="referral.referredName"
                          required>
                      </div>

                      <div class="col-md-6 mb-3">
                        <label for="referredEmail" class="form-label">Email</label>
                        <input type="email" class="form-control" id="referredEmail" v-model="referral.referredEmail"
                          required>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="referredPhone" class="form-label">Telefon</label>
                      <input type="tel" class="form-control" id="referredPhone" v-model="referral.referredPhone">
                    </div>

                    <div class="mb-4">
                      <label for="referralMessage" class="form-label">Dodatkowa wiadomość (opcjonalnie)</label>
                      <textarea class="form-control" id="referralMessage" rows="3"
                        v-model="referral.message"></textarea>
                    </div>

                    <div class="form-check mb-4">
                      <input class="form-check-input" type="checkbox" id="referralConsent" v-model="referral.consent"
                        required>
                      <label class="form-check-label" for="referralConsent">
                        Potwierdzam, że osoba którą polecam wyraziła zgodę na przekazanie jej danych kontaktowych.
                      </label>
                    </div>

                    <button type="submit" class="btn btn-primary btn-lg" :disabled="isSubmittingReferral">
                      <span v-if="isSubmittingReferral">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Wysyłanie...
                      </span>
                      <span v-else>Poleć znajomego</span>
                    </button>

                    <div v-if="referralStatus.message"
                      :class="['alert mt-4', referralStatus.success ? 'alert-success' : 'alert-danger']">
                      {{ referralStatus.message }}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mapa -->
        <!-- Mapa -->
        <div class="row mt-5">
          <div class="col-12">
            <div class="map-container rounded shadow-sm overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2442.0916290860577!2d20.889913876506622!3d52.25940205333247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb1a8ca29999%3A0xebd0ef1e4ce4d6e5!2sGo%C5%9Bcinna%207%2C%2005-082%20Blizne%20%C5%81aszczy%C5%84skiego!5e0!3m2!1spl!2spl!4v1711927863594!5m2!1spl!2spl"
                width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        consent: false
      },
      isSubmitting: false,
      formStatus: {
        success: false,
        message: ''
      },
      referral: {
        referrerName: '',
        referrerEmail: '',
        referredName: '',
        referredEmail: '',
        referredPhone: '',
        message: '',
        consent: false
      },
      isSubmittingReferral: false,
      referralStatus: {
        success: false,
        message: ''
      }
    }
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true;
      this.formStatus.message = '';

      try {
        // Wysyłanie formularza za pomocą PHPMailer
        const formData = new FormData();
        formData.append('type', 'contact');
        formData.append('name', this.form.name);
        formData.append('email', this.form.email);
        formData.append('phone', this.form.phone);
        formData.append('subject', this.form.subject);
        formData.append('message', this.form.message);

        // W środowisku produkcyjnym użyj ścieżki względnej
        const response = await axios.post('/send-email-phpmailer.php', formData);

        // Podczas developmentu możesz potrzebować pełnego URL
        // const response = await axios.post('http://twoja-domena.pl/send-email-phpmailer.php', formData);

        // Alternatywnie, możesz wysłać dane jako JSON
        // const response = await axios.post('/send-email-phpmailer.php', {
        //   type: 'contact',
        //   name: this.form.name,
        //   email: this.form.email,
        //   phone: this.form.phone,
        //   subject: this.form.subject,
        //   message: this.form.message
        // });

        if (response.data.success) {
          this.formStatus.success = true;
          this.formStatus.message = 'Dziękujemy! Twoja wiadomość została wysłana. Skontaktujemy się z Tobą wkrótce.';

          // Resetowanie formularza po pomyślnym wysłaniu
          this.form = {
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            consent: false
          };
        } else {
          throw new Error(response.data.message || 'Wystąpił błąd podczas wysyłania wiadomości');
        }
      } catch (error) {
        console.error('Błąd wysyłania formularza:', error);
        this.formStatus.success = false;
        this.formStatus.message = error.response?.data?.message || error.message || 'Nie udało się wysłać wiadomości. Spróbuj ponownie później lub skontaktuj się z nami telefonicznie.';
      } finally {
        this.isSubmitting = false;
      }
    },

    async submitReferral() {
      this.isSubmittingReferral = true;
      this.referralStatus.message = '';

      try {
        // Wysyłanie formularza polecającego za pomocą PHPMailer
        const formData = new FormData();
        formData.append('type', 'referral');
        formData.append('referrerName', this.referral.referrerName);
        formData.append('referrerEmail', this.referral.referrerEmail);
        formData.append('referredName', this.referral.referredName);
        formData.append('referredEmail', this.referral.referredEmail);
        formData.append('referredPhone', this.referral.referredPhone);
        formData.append('message', this.referral.message);

        // W środowisku produkcyjnym użyj ścieżki względnej
        const response = await axios.post('/send-email-phpmailer.php', formData);

        // Podczas developmentu możesz potrzebować pełnego URL
        // const response = await axios.post('http://twoja-domena.pl/send-email-phpmailer.php', formData);

        if (response.data.success) {
          this.referralStatus.success = true;
          this.referralStatus.message = `Dziękujemy za polecenie ${this.referral.referredName}! Wkrótce się z nim skontaktujemy.`;

          // Resetowanie formularza polecenia
          this.referral = {
            referrerName: '',
            referrerEmail: '',
            referredName: '',
            referredEmail: '',
            referredPhone: '',
            message: '',
            consent: false
          };
        } else {
          throw new Error(response.data.message || 'Wystąpił błąd podczas wysyłania polecenia');
        }
      } catch (error) {
        console.error('Błąd wysyłania polecenia:', error);
        this.referralStatus.success = false;
        this.referralStatus.message = error.response?.data?.message || error.message || 'Nie udało się wysłać polecenia. Spróbuj ponownie później lub skontaktuj się z nami telefonicznie.';
      } finally {
        this.isSubmittingReferral = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-view {
  .page-header {
    background-color: #f1f8ff;

    h1 {
      color: var(--primary-color);
    }
  }

  .contact-info-card,
  .contact-form-card {
    height: 100%;

    h3 {
      color: var(--primary-color);
      position: relative;
      padding-bottom: 15px;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 50px;
        height: 3px;
        background-color: var(--secondary-color);
      }
    }
  }

  .contact-item {
    .contact-icon {
      color: var(--secondary-color);
    }

    h5 {
      color: var(--primary-color);
      margin-bottom: 0.3rem;
    }

    a {
      color: var(--text-color);
      transition: color 0.3s ease;

      &:hover {
        color: var(--secondary-color);
      }
    }
  }

  .contact-tabs {
    .nav-link {
      color: var(--text-color);
      font-weight: 500;

      &.active {
        color: var(--primary-color);
        border-bottom-color: var(--primary-color);
      }
    }
  }

  .social-links {
    .social-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: #f1f8ff;
      color: var(--secondary-color);
      border-radius: 50%;
      transition: all 0.3s ease;

      &:hover {
        background-color: var(--secondary-color);
        color: white;
      }
    }
  }

  .map-container {
    height: 450px;
  }
}
</style>